export default "__VITE_ASSET__DnjMnU3s__"